import NoStyleButton from '~/components/common/Button/NoStyle';
import HtmlText from '~/components/common/HtmlText';
import useSingletonRequestAnimationFrame from '~/hooks/useSingletonRequestAnimationFrame';
import { isNonEmpty } from '~/utils/fnUtil/fnUtil';
import classNames from 'classnames/bind';
import { isNumber, isString } from 'lodash';
import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { useCallback } from 'react';

import ActionButton from './ActionButton/ActionButton';
import NotificationIcon from './Icon/NotificationIcon';
import styles from './notification.module.scss';

const cx = classNames.bind(styles);

type Props = {
  notification: any;
  close: (id: string) => void;
};

const Notification: React.FC<Props> = ({ notification, close }) => {
  const store = useLocalStore(() => ({
    show: false,
    setShow(value) {
      this.show = value;
    },
  }));
  const { id, noDismiss, text, title, timeout } = notification;
  const onClickClose = () => {
    close(id);
  };

  const lazySetShow = useSingletonRequestAnimationFrame(
    useCallback(() => {
      store.setShow(true);
    }, [store])
  );

  React.useLayoutEffect(() => {
    lazySetShow();
    if (!isNumber(timeout) || timeout === 0) return;
    const timerId = setTimeout(() => store.setShow(false), timeout - 500);
    return () => {
      clearTimeout(timerId);
      lazySetShow.dispose();
    };
  }, [lazySetShow, store, timeout]);

  return (
    <div className={cx('wrapper', { show: store.show })}>
      {!noDismiss && (
        <NoStyleButton onClick={onClickClose}>
          <div className={styles.close} />
        </NoStyleButton>
      )}
      {isNonEmpty(text) && (
        <div className={styles.contents}>
          <NotificationIcon notification={notification} />
          <div className={styles.right}>
            {title && <div className={styles.title}>{title}</div>}
            <div>
              <HtmlText html={isString(text) ? text : JSON.stringify(text)} />
            </div>
            <ActionButton notification={notification} />
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(Notification);
